// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 25) return "./default/chunk-html-box-reg-wall.fe0cf62d4763404d165a.js";
	if (chunkId === 35) return "./default/chunk-recombee-init.c6bbc14c2b8c5a900208.js";
	if (chunkId === 26) return "./default/chunk-lazyload-images.e7fee369096c12481216.js";
	if (chunkId === 23) return "./default/chunk-gtm-highlight.d161fdf894a6eac53003.js";
	if (chunkId === 33) return "./default/chunk-progressBar.9d2c33f8feecd37b2849.js";
	if (chunkId === 15) return "./default/chunk-accordion.3a90f8cefd39ca11e6a5.js";
	if (chunkId === 20) return "./default/chunk-fadeInOnEnterViewport.8084823fc03bf4366189.js";
	if (chunkId === 29) return "./default/chunk-megamenu.dbe8d29a3e5017f169ea.js";
	if (chunkId === 24) return "./default/chunk-header.d4ae529e08ebf1c85c2d.js";
	if (chunkId === 28) return "./default/chunk-mainNavigation.7136193467ef9a32f02d.js";
	if (chunkId === 30) return "./default/chunk-modal.6ff867240eb90ec213af.js";
	if (chunkId === 67) return "./67.7e3bdb34501534dcc15d.js";
	if (chunkId === 22) return "./default/chunk-gallery.b603b0372066d96dac84.js";
	if (chunkId === 19) return "./default/chunk-enquiry.dc1c1e86e7085365ed55.js";
	if (chunkId === 39) return "./default/chunk-survey.bf64d6ee711711a9d965.js";
	if (chunkId === 21) return "./default/chunk-forum.4b5d3d24a637d387196c.js";
	if (chunkId === 63) return "./63.5a55341772839a013025.js";
	if (chunkId === 34) return "./default/chunk-recombee.cddb3da5b4f337a3a392.js";
	if (chunkId === 64) return "./64.d913dd4e819b08072824.js";
	if (chunkId === 27) return "./default/chunk-load-more.d6f96a2fd58c103d6da9.js";
	if (chunkId === 41) return "./default/chunk-uncover-behav-articles.317b1742bdb354b1cbd6.js";
	if (chunkId === 16) return "./default/chunk-ads-repeater.d0b2cb58340db94e614a.js";
	if (chunkId === 48) return "./default/newsletter.d4c96a12fdf41ea803fa.js";
	if (chunkId === 43) return "./default/companySubscription.82de06dc553eb32b5c52.js";
	if (chunkId === 52) return "./default/swiper.1c5111460968099f7353.js";
	if (chunkId === 54) return "./default/thingsArticleSwiper.32ffa28e6d26a7d2ed3c.js";
	if (chunkId === 18) return "./default/chunk-editorial-promo.a3c3596efac768bca62d.js";
	if (chunkId === 55) return "./default/topic-banner.02d5b6b45614a5851fbe.js";
	if (chunkId === 46) return "./default/instagram.dd18842a7ccb3875399c.js";
	if (chunkId === 49) return "./default/piano.34088573d0b1a2dd5318.js";
	if (chunkId === 65) return "./65.dfa1cee5ff75121f36af.js";
	if (chunkId === 50) return "./default/portaInit.f66d3de1662e473dc7c5.js";
	if (chunkId === 47) return "./default/jakebox.f8253255a7db4958f6dc.js";
	if (chunkId === 42) return "./default/collapser.47407bc27b5958e7bef5.js";
	if (chunkId === 14) return "./default/author-card-list.2637f9603418ada7d05f.js";
	if (chunkId === 51) return "./default/rename-article-list.3e4dabc4a4e5e461bbd9.js";
	if (chunkId === 12) return "./chunk-todayResultSliderHP.386e188cd03ef87c14f0.js";
	if (chunkId === 7) return "./chunk-previewMatchesListVideoSlider.d79694757a2e6d487525.js";
	if (chunkId === 5) return "./chunk-headermenuflat.80287d405667c82298a8.js";
	if (chunkId === 45) return "./default/info-toggle.b911b5730fcf2d6f712c.js";
	if (chunkId === 53) return "./default/tabs.628171a55ceb3cac0cd7.js";
	if (chunkId === 11) return "./chunk-sportmodDayResultDatepicker.78cef88bbc0f1a842f5e.js";
	if (chunkId === 66) return "./66.1bb32c0360f45c207e5b.js";
	if (chunkId === 9) return "./chunk-sportmod-live-match-websocket-updater.36337cb07eca4c0ee20c.js";
	if (chunkId === 8) return "./chunk-sportmod-league-phase-reloader.d5ca63f6d0a138c56158.js";
	if (chunkId === 10) return "./chunk-sportmod-matches-with-table-phase-reloader.59fa13d33ff4b21739b1.js";
	if (chunkId === 4) return "./chunk-category-content-loader.bdb1ade4facc82170c0e.js";
	if (chunkId === 13) return "./chunk-top-feed-responsive-behavior.8feedebc0716a5d50666.js";
	// return url for filenames based on template
	return undefined;
};